

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister 
// CUSTOMERREGISTER
const RESETPASSWORDFORUSER= createAsyncThunk(
  "resetPasswordForUser/resetPasswordForUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const resetPasswordForUserSlice = createSlice({
  name: "resetPasswordForUserSlice",
  initialState: {
    resetPasswordForUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfresetPasswordForUser: (state) => {
        state.resetPasswordForUser.loading = false
        state.resetPasswordForUser.error = false
        state.resetPasswordForUser.data = []
        state.resetPasswordForUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(RESETPASSWORDFORUSER.fulfilled, (state, action) => {
      state.resetPasswordForUser = {
        ...state.resetPasswordForUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(RESETPASSWORDFORUSER.pending, (state, action) => {
      state.resetPasswordForUser = {
        ...state.resetPasswordForUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(RESETPASSWORDFORUSER.rejected, (state, action) => {
      state.resetPasswordForUser = {
        ...state.resetPasswordForUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const resetPasswordForUserAction = {
    RESETPASSWORDFORUSER,
};

export { resetPasswordForUserAction };
export default resetPasswordForUserSlice.reducer;
export const {setInitialStateOfresetPasswordForUser} = resetPasswordForUserSlice.actions
